import React from 'react';
import {auth,firestore} from '../../firebase/firebase.utils'
import {Link} from 'react-router-dom'
class Signin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signInEmail: '',
      signInPassword: ''
    }
  }
 forgotPassoword = () => {
    auth.sendPasswordResetEmail(this.state.signInEmail).then(function() {
      alert('Email Sent')
    }).catch(function(error) {
      alert('Could not find your email address')
    });
  }

  onEmailChange = (event) => {
    this.setState({signInEmail: event.target.value})
  }

  onPasswordChange = (event) => {
    this.setState({signInPassword: event.target.value})
  }

  onSubmitSignIn = async () => {
    try {
        const that = this
        const d = await auth.signInWithEmailAndPassword(this.state.signInEmail,this.state.signInPassword); 
        firestore.collection("users").where("email", "==", d.user.email)
        .get()
        .then(function(docs) {
          // console.log(docs);
          docs.forEach(doc=>{
            // console.log(doc.data());
            that.props.loadUser(doc.data())
          })
        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });
    } catch (error) {
        // console.log(error)
        alert(error)
    }
  }

  render() {
    return (
      <article className="br3 ba b--black-10 mv4 w-100 w-50-m w-25-l mw6 shadow-5 center">
        <main className="pa4 black-80">
          <div className="measure">
            <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
              <legend className="f1 fw6 ph0 white mh0">Sign In</legend>
              <div className="mt3">
                <label className="db fw6 lh-copy white f6" htmlFor="email-address">Email</label>
                <input
                  className="pa2 input-reset white ba bg-transparent hover-bg-black hover-white w-100"
                  type="email"
                  name="email-address"
                  id="email-address"
                  required
                  onChange={this.onEmailChange}
                />
              </div>
              <div className="mv3">
                <label className="db fw6 white lh-copy f6" htmlFor="password">Password</label>
                <input
                  className="b pa2 white input-reset ba bg-transparent hover-bg-black hover-white w-100"
                  type="password"
                  name="password"
                  id="password"
                  required
                  minLength="8"
                  onChange={this.onPasswordChange}
                />
              </div>
            </fieldset>
            <div className="">
              <input
                onClick={this.onSubmitSignIn}
                className="b ph3 pv2  input-reset ba b--white white bg-transparent grow pointer f6 dib"
                type="submit"
                value="Sign in"
              />
            </div>
            <div className="lh-copy mt3">
              <Link to="/signup"><p className="f6 link dim white db pointer">Register</p></Link>
              <p onClick={this.forgotPassoword} className="f6 link dim white db pointer">Forgot Password(Email written in the Signin field will be used</p>
            </div>
          </div>
        </main>
      </article>
    );
  }
}

export default Signin;